import React, { useEffect, useState } from "react";
import AppModal from "./AppModal";

const TaskModal = ({ show, setShow, editData = null }) => {
  const isEdit = editData !== null;

  const [formData, setFormData] = useState({
    task_name: "",
    priority: "",
    status: "",
    assigned: "",
    start_date: "",
    due_date: "",
    project_name: "",
    estimated_hours: "",
    description: "",
  });

  // Set Edit Data
  useEffect(() => {
    if (editData) {
      setFormData({
        task_name: editData.task_name || "",

        priority: editData.priority || "",

        status: editData.status || "",

        assigned: editData.assigned || "",

        start_date: editData.start_date || "",

        due_date: editData.due_date || "",

        project_name: editData.project_name || "",

        estimated_hours: editData.estimated_hours || "",

        description: editData.description || "",
      });
    } else {
      // Reset Form
      setFormData({
        task_name: "",
        priority: "",
        status: "",
        assigned: "",
        start_date: "",
        due_date: "",
        project_name: "",
        estimated_hours: "",
        description: "",
      });
    }
  }, [editData, show]);

  // Input Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Submit
  const handleSubmit = () => {
    if (isEdit) {
      console.log("Update Task:", formData);
    } else {
      console.log("Add Task:", formData);
    }

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      title={isEdit ? "Edit Task" : "Add New Task"}
      size="modal-lg"
      footer={
        <>
          <button className="btn btn-danger" onClick={() => setShow(false)}>
            Cancel
          </button>

          <button className="btn btn-primary" onClick={handleSubmit}>
            {isEdit ? "Update Task" : "Save Task"}
          </button>
        </>
      }
    >
      <div className="row">
        {/* Task Name */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Task Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter task name"
            name="task_name"
            value={formData.task_name}
            onChange={handleChange}
          />
        </div>

        {/* Priority */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Priority</label>

          <select
            className="form-select"
            name="priority"
            value={formData.priority}
            onChange={handleChange}
          >
            <option value="">Select Priority</option>

            <option value="Low">Low</option>

            <option value="Medium">Medium</option>

            <option value="High">High</option>

            <option value="Urgent">Urgent</option>
          </select>
        </div>

        {/* Status */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Status</label>

          <select
            className="form-select"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="">Select Status</option>

            <option value="Pending">Pending</option>

            <option value="In Progress">In Progress</option>

            <option value="Completed">Completed</option>
          </select>
        </div>

        {/* Assign User */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Assign To</label>

          <select
            className="form-select"
            name="assigned"
            value={formData.assigned}
            onChange={handleChange}
          >
            <option value="">Select User</option>

            <option value="Amit">Amit</option>

            <option value="Rahul">Rahul</option>

            <option value="Sonia">Sonia</option>

            <option value="Vikas">Vikas</option>
          </select>
        </div>

        {/* Start Date */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Start Date</label>

          <input
            type="date"
            className="form-control"
            name="start_date"
            value={formData.start_date}
            onChange={handleChange}
          />
        </div>

        {/* Due Date */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Due Date</label>

          <input
            type="date"
            className="form-control"
            name="due_date"
            value={formData.due_date}
            onChange={handleChange}
          />
        </div>

        {/* Project Name */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Project Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter project name"
            name="project_name"
            value={formData.project_name}
            onChange={handleChange}
          />
        </div>

        {/* Estimated Hours */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Estimated Hours</label>

          <input
            type="number"
            className="form-control"
            placeholder="Enter estimated hours"
            name="estimated_hours"
            value={formData.estimated_hours}
            onChange={handleChange}
          />
        </div>

        {/* Attachment */}
        <div className="col-md-12 mb-3">
          <label className="form-label">Attachment</label>

          <input type="file" className="form-control" />
        </div>

        {/* Description */}
        <div className="col-md-12 mb-3">
          <label className="form-label">Description</label>

          <textarea
            rows="5"
            className="form-control"
            placeholder="Write task description..."
            name="description"
            value={formData.description}
            onChange={handleChange}
          ></textarea>
        </div>
      </div>
    </AppModal>
  );
};

export default TaskModal;
